import { useEffect, useRef, useState } from 'react';
import lottie from 'lottie-web';
import styles from './home-animation.module.css'
import NavBar from '../nav-bar/nav-bar';
import { ShareButton } from '../share-button/shareButton';

export default function HomeAnimation({ onStart }) {
    const containerRef = useRef(null);
    const secondContainerRef = useRef(null);
    const audioRef = useRef(null);
    const [openTerms, setOpenTerms] = useState(false);
    const [readTerms, setReadTerms] = useState(false);
    const [showError, setShowError] = useState(false);


    const handleStart = () => {
        if (!readTerms) {
            setShowError(true);
            return;
        }

        setShowError(false);
        onStart();
    };

    useEffect(() => {
        const anim1 = lottie.loadAnimation({
            container: containerRef.current,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: '/lottie/character/data.json',
        });

        const anim2 = lottie.loadAnimation({
            container: secondContainerRef.current,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: '/lottie/ants/data.json',
        });

        const audio = audioRef.current;
        if (!audio) return;

        const playPromise = audio.play();
        if (playPromise !== undefined) {
            playPromise.catch(() => {
                const startAudio = () => {
                    audio.play();
                    window.removeEventListener('click', startAudio);
                    window.removeEventListener('keydown', startAudio);
                };
                window.addEventListener('click', startAudio);
                window.addEventListener('keydown', startAudio);
            });
        }

        return () => {
            anim1.destroy();
            anim2.destroy();
        };
    }, []);

    return (

        <>
            <NavBar></NavBar>
            <div className={styles.animationWrap}>
                <div className={styles.starsWrap}>
                    <div id='stars'></div>
                    <div id='stars2'></div>
                    <div id='stars3'></div>
                </div>
                <audio ref={audioRef} muted src="/sound/home-bg-music.mp3" loop preload="auto" />
                <div className={styles.formWrap}>
                    <div
                        className={styles.qodo}
                        ref={containerRef}
                    />
                    <div className={styles.textWrap}>
                        <span className={styles.flashText}>
                            BUG CHASE (AI VS HUMAN)
                        </span>
                        <div className={styles.instructionsBox}>
                            <h3>
                                How to win:
                            </h3>
                            <div className={styles.line}>
                                Play the game and get the highest score you can.
                            </div>
                            <p>or</p>
                            <div className={styles.line}>
                                Share the game on Twitter and enter a $100 gift card raffle.
                            </div>
                            <ShareButton></ShareButton>
                        </div>

                        <button className={styles.playBtn} onClick={handleStart}>
                            PLAY
                        </button>

                        <div className="customCheckboxWrapper">
                            <label className="customCheckboxLabel">
                                <input
                                    type="checkbox"
                                    checked={readTerms}
                                    onChange={(e) => {
                                        setReadTerms(e.target.checked);
                                        setShowError(false); // clear error when user checks it
                                    }}
                                />
                                <span className="customCheckbox"></span>
                                I have read and agree to the&nbsp;
                                <button
                                    type="button"
                                    className={styles.termsLink}
                                    onClick={() => setOpenTerms(true)}
                                >
                                    terms and conditions
                                </button>.
                            </label>

                            {showError && (
                                <div className={styles.checkboxError}>
                                    Please agree to the terms and conditions to continue
                                </div>
                            )}
                        </div>

                    </div>
                </div>
                <div className={styles.ants} ref={secondContainerRef} />
            </div>







            {openTerms && (
                <div className={styles.dialogOverlay} onClick={() => setOpenTerms(false)}>
                    <div
                        className={styles.dialog}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h2>Qodo – General Promotion Rules
                            <br></br>
                            Effective as of February 2, 2026

                        </h2>

                        <div className={styles.dialogContent}>


                            The following are the terms and conditions (the &quot;Terms&quot;) governing promotional
                            activities (the &quot;Promotion&quot;) offered within an online game (the &quot;Game&quot;) operated and
                            administered by Codium Ltd., (&quot;us&quot;, &quot;we&quot;, &quot;our&quot;, &quot;Qodo&quot; or &quot;Company&quot;).
                            Participating in the Promotion, is subject by these Terms, the Terms of Use (&quot;Terms of
                            Use&quot;), Privacy Policy (&quot;Privacy Policy&quot;), and any and all other terms and conditions
                            relating to the Promotion (&quot;Additional Rules&quot;) as determined in Qodo sole discretion.
                            You agree, represent and warrant that, as a condition of participating in the Promotion
                            (including, without limitation, eligibility to win any Prizes (as defined below), you will
                            comply with all applicable laws, regulations, statutes, ordinances and rules. You further
                            acknowledge that you have read, understand and agree to be bound by these Terms,
                            any applicable Additional Rules, the Terms of Use and the Privacy Policy. If you do not
                            agree to any of the foregoing, you must not participate in the Promotion.
                            Capitalized terms used but not defined herein shall have the meaning given to them in
                            the Terms of Use.

                            <p>
                                General
                            </p>
                            <ul>
                                <li>
                                    1. The Promotion shall commence on February 2, 2026 and shall conclude on April, 2026 (the “Promotion Period”).
                                </li>
                                <li>
                                    2. The Promotion Period is comprised of consecutive weekly rounds (each a “Weekly Round”). Each Weekly Round begins at 00:00 and ends at 23:59:59 on the seventh day, based on Qodo server time (Israel time). At the start of each Weekly Round, the leaderboard will be reset and results from prior Weekly Rounds will not carry over. Subject to these Terms, the Game Prize and the Giveaway Prize may be awarded separately for each Weekly Round. The first Weekly Round will begin on the Promotion commencement date at 00:00 (Qodo server time), that is: February 9, 2026.
                                </li>
                                <li>
                                    3. There is no cost and no purchase necessary to enter the Promotion. The
                                    requirements for participating are described below.
                                </li>
                            </ul>

                            <p>
                                Eligibility
                            </p>
                            <ul>
                                <li>
                                    4. To participate in the Promotion, you represent and warrant that you:
                                    (i) are at least eighteen (18) years old of age (or the applicable age of majority or
                                    consent in your jurisdiction of residence at the time of entry, if higher); and (ii) are
                                    eligible under any applicable law and have full right to participate in the
                                    Promotion.
                                </li>
                                <li>
                                    5. We reserve that right, at any time to require participants to provide us or our
                                    designated third party with additional information in order to confirm eligibility, such
                                    as, but not limited to, proof of your age, identity or residency, and you must, upon
                                </li>

                            </ul>

                            <p>
                                Effective as of January [XXX], 2026
                            </p>

                            <ul>
                                <li className="bullet-title">
                                    request, be able to present valid documentation which may enable us to verify
                                    your age, residency and identity to our reasonable satisfaction. Failure to provide
                                    satisfactory documentation within a reasonable timeframe, as determined by us,
                                    may result in disqualification from the Promotion, and any associated Prizes or
                                    privileges may be forfeited without compensation of any kind. To the maximum
                                    extent permitted by applicable law, you hereby irrevocably waive any claims or
                                    rights in connection with any such disqualification or forfeiture.
                                </li>
                                <li>
                                    6. Participants may also be subject to additional verification requirements, as
                                    determined by Qodo at its sole discretion, in order to ensure the integrity of the
                                    Promotion and ensure compliance with applicable laws, the Terms, and Qodo&#39;s
                                    policies. Participants failing to satisfy these requirements within the timeframes
                                    specified by Qodo may not be eligible to participate in the Promotion or win any
                                    Prizes.                                </li>
                                <li>
                                    7. Any employees, officers, directors and representatives, promotion agencies or
                                    sponsors of Qodo and any of its affiliates, subsidiaries, and advertising,
                                    promotion, fulfillment agencies, and legal advisors and the immediate family and
                                    other household members (i.e., spouses, parents, grandparents, children,
                                    grandchildren, roommates, housemates, significant others, partners, and
                                    siblings) are not eligible to participate or win the Promotion.                                </li>
                                <li>
                                    8. In order to be eligible to win the Prizes you must (i) provide your true and valid
                                    email address and full name; providing incorrect or incomplete details may result
                                    in disqualification or forfeiture of the Prizes, at the Company’s sole discretion;
                                    and (ii) enter to the Promotion during the Promotion Period.                                </li>
                                <li>
                                    9. Only one entry to the Promotion per person is permitted during the Promotion Period.                              </li>
                                <li>
                                    10. Entrants can win only one Game Prize in Promotion during the Promotion Period. An entrant may win the Game Prize and may also win the Giveaway Prize.                              </li>


                            </ul>

                            <p>
                                How to enter the Promotion, selection of winners and Prizes
                            </p>
                            <ul>
                                <li className="bullet-title">
                                    Stage 1 – Game contest
                                </li>
                                <li>
                                    11. During the Promotion Period you can participate in the Promotion by accessing
                                    the following link [____] to the Game and by following the instructions within.                                </li>
                                <li>
                                    12. You must enter the Game during the Promotion Period. Any entries before or
                                    after the specified Promotion Period will not be considered valid.                                </li>

                                <li>
                                    13. The Game consists of a series of questions that participants are required to solve
                                    and answer as accurately as possible, in the manner and within the time limits
                                    specified in the Game, in accordance with any rules provided to the participants
                                    in the Game.
                                </li>

                                <li>
                                    14. Subject to these Terms, a winner in the Promotion who is entitled to the Game
                                    Prize is a participant who successfully completes all assignments of the Game in
                                    accordance with the instructions provided, and whose results place them first on
                                    the leaderboard for that Weekly Round.
                                </li>
                                <li>
                                    15. Subject to these Terms, in each Weekly Round, Qodo will offer the winner who successfully completed all the required tasks in the Game and provided all required information, to the full satisfaction of the Company, at its sole discretion, and ranked as the first participant at the leaderboard in such Weekly Round, a non-transferable and not assignable, non-cash digital gift card with a value of one hundred and fifty USD ($150), issued by a third party retailer selected by the Company in its sole discretion (the “Game Prize”).
                                </li>
                                <li>
                                    16. If two or more participants tie for the highest score in a Weekly Round, the Game
                                    Prize for that Weekly Round will be awarded to the first [___] tied participants as
                                    recorded on the leaderboard, in chronological order (first recorded on the
                                    leaderboard, as determined solely by Qodo systems).
                                </li>
                                <li className="bullet-title">
                                    Stage 2 – Giveaway
                                </li>
                                <li>
                                    17. Participants who completed the Game may also participate in a giveaway
                                    (&quot;Giveaway&quot;), subject to the rules below.
                                </li>
                                <li>
                                    18. The winner in the giveaway shall be entitled to the Giveaway Prize (as defined
                                    below) and shall be selected by a random draw of all eligible entries of
                                    participants in the Weekly Round who have:
                                    <ul>
                                        <li>
                                            a. Successfully completed the Game;
                                        </li>
                                        <li>
                                            b. Share the [Game, and results] on their "X" (formally Twitter) account and in accordance with the instruction withing the Game and submit proof of such sharing at Company's request.
                                        </li>
                                    </ul>
                                    All in accordance with the instructions communicated to you. Sharing is optional
                                    and is not required to enter the Promotion or to be eligible for the Game Prize
                                    awarded to the first place participant on the leaderboard.
                                </li>
                                <li>
                                    19. Subject to these Terms, Qodo will offer the winner who successfully completed all the required tasks in the Giveaway and provided all required information, to the full satisfaction of the Company, at its sole discretion, a non-transferable and not assignable, non-cash digital gift card in the value of one hundred USD ($100), issued by a third party retailer selected by the Company in its sole discretion (the "Giveaway Prize", collectively with the Game Prize on section 15 above the "Prizes"). The random draw for the Giveaway will be conducted separately for each Weekly Round from all eligible entries received during that Weekly Round.
                                </li>
                                <li>
                                    20. Qodo shall not be liable for any problems that occur during the entry process,
                                    including, without limitation, late, incomplete, delayed, undelivered, or
                                    misdirected entries, and shall not have any obligation to advise you of an
                                    incomplete, invalid, or undeliverable submission. No other form or method of
                                    submitting an entry, other than the ones mentioned in the Terms or the Additional
                                    Rules, will be considered.
                                </li>
                            </ul>

                            <p>
                                Prizes
                            </p>
                            <ul>
                                <li>
                                    21. Odds of winning the Giveaway Prize depend on the number of eligible entries
                                    received during the applicable Weekly Round. If any of the Prizes, or any portion
                                    thereof, cannot be granted for any reason, we reserve the right (but not the
                                    obligation) to substitute it for one of equal or greater value, in our sole discretion.
                                </li>
                                <li>
                                    22. You shall be solely responsible for any taxes or fees associated with your receipt
                                    of Prizes. Any and all taxes on Prizes, and any other expenses not explicitly
                                    stated herein, are the sole responsibility of the Prizes&#39; recipient.
                                </li>
                            </ul>

                            <p>
                                Winner Notification and Prizes Claim Process
                            </p>

                            <ul>
                                <li>
                                    23. Each participant shall provide its contact information (e.g. email and full name),
                                    at the end of the Game, in order to display the participant&#39;s Game results and
                                    being listed in the leaderboard weekly ranking, to participate in the draw and to
                                    receive the Prizes if applicable. If participant does not provide such information at
                                    the end of the Game, or it is otherwise disqualified or does not comply with these
                                    Terms, participant will not be entitled to see the Game results, be listed on the
                                    leaderboard, being eligible to participate in the draw or winning any Prizes.
                                </li>
                                <li>
                                    24. By participating in the Promotion, you allow Qodo, or any third party on their
                                    behalf, to contact you through any communication channel, including but not
                                    limited to any email, for the purpose of administration of the Promotion and
                                    awarding of the Prizes and collecting any necessary information and
                                    documentation as part of the Promotion.
                                </li>
                                <li>
                                    25. Qodo will notify each potential winner by sending notification via the contact
                                    details provided by the potential winners, within ten (10) business days from the
                                    end of each Weekly Round. We will make only three (3) attempts to contact the
                                    potential winners within that time frame. It is your sole responsibility to notify us in
                                    writing if you change your email address or other contact details during the
                                    Promotion Period.
                                </li>
                                <li>
                                    26. If we are unable to contact the potential winner within the specified time frame
                                    mentioned above, or is otherwise disqualified or does not comply with these
                                    Terms, the Terms of Use, or any Additional Rules, as applicable, Qodo may
                                    forfeit the Prizes and grant it to the next highest eligible participant on the
                                    leaderboard in such Weekly Round (with regards to the Giveaway Prize,
                                    conducting additional draw in accordance with these Terms).
                                </li>
                                <li>
                                    27. Prizes will be delivered to winners up to ten (10) business days from Qodo
                                    receiving all information required and winners complying with all conditions and
                                    requirements, unless Qodo, in its sole discretion, has any reason to believe that
                                    the winner is not eligible to participate in the Promotion or to be awarded the
                                    Prizes.
                                </li>
                            </ul>

                            <p>
                                Limitation of Liability and Release
                            </p>
                            <ul>
                                <li>
                                    28. By entering into a Promotion, you agree to release, indemnify, defend and hold
                                    harmless Qodo, and its respective parents, subsidiaries, affiliates, distributors,
                                    suppliers, and advertising, promotional and judging organizations and each of
                                    their respective employees, officers, directors, shareholders, and agents
                                    (collectively, the “Releasees”) from and against any and all (including third-party)
                                    claims, actions, damages, losses, liabilities, costs, expenses, injuries, or causes
                                    of action of any kind that in any way now or hereinafter may arise from or relate
                                    to the Promotion (including reasonable attorneys/legal fees), including without
                                    limitation (i) the administration of the Promotion and the Game, such as
                                    typographical, printing, seeding, human or other errors, omissions or
                                    interruptions relating to or in connection with the Promotion; (ii) the processing of
                                    entries, the announcement of the Prizes or any related materials; (iii) inaccurate,
                                    fraudulent, incomplete, illegible, late, lost, stolen, misdirected, undelivered,
                                    incomplete, or damaged entries or any delays in delivery or lack of availability of
                                    a Prizes; (iv) your participation in the Promotion or your acceptance or use or
                                    misuse of any Prizes, or participation in any prize related activities, including,
                                    without limitation, any travel related thereto, and death and bodily injury
                                    (including emotional distress), due in whole or in part, directly or indirectly, to
                                    participation in the Promotions or any Promotion-related activity; or (v) for any
                                    claims or causes of action based on publicity rights, defamation, or invasion of
                                    privacy. In no event will the Releasees be responsible or liable for any damages
                                    or losses of any kind, including indirect, incidental, consequential or punitive
                                    damages, other than your actual out-of-pocket expenses arising out of your
                                    participation in a Promotion. Without limiting the foregoing, the Promotion,
                                    services and prizes are provided “as is” without warranty of any kind, either
                                    expressed or implied, including but not limited to, the implied warranties of merchantability, fitness for a particular purpose or non-infringement. Some
                                    jurisdictions may not allow the limitations or exclusion of liability for incidental or
                                    consequential damages or exclusion of implied warranties, so some of the above
                                    limitations or exclusions may not apply to you. In such cases, our liability will be
                                    limited to the fullest extent permitted by applicable law.
                                </li>
                                <li>
                                    29. By participating in any Promotion, the winners in the Prizes irrevocably release
                                    and forever discharge the Releasees from any future claims arising from the
                                    Promotion, the Services or the Prizes. By accepting the Prizes, the winners
                                    agree that they will not assert or maintain against Qodo, its successors, assigns
                                    and licensees, any claim, action, suit or demand of any kind or nature
                                    whatsoever, including but not limited to those grounded upon invasion of privacy,
                                    rights of publicity or other civil rights, or for any reason in connection with their
                                    participation in the Promotion, the Services or accepting the Prizes.
                                </li>
                            </ul>

                            <p>
                                Cheating and Fraud
                            </p>

                            <ul>
                                <li>
                                    30. If Qodo becomes aware that you have engaged in any fraud, deceit, dishonesty,
                                    cheating, misconduct, or any unsportsmanlike, disruptive, abusive, harassing, or
                                    manipulative behavior, or any action intended to disrupt, interfere with, or
                                    undermine the legitimate or fair operation of a Promotion or the Services, or if
                                    you have violated these Terms, any Additional Rules, the Terms of Use or any
                                    applicable laws or regulations (&quot;Prohibited Conduct&quot;), you may be subject to
                                    enforcement action. Without limiting the foregoing, Prohibited Conduct includes
                                    the use of automated, robotic, mechanical, or pre-programmed entry methods, as
                                    well as the use of multiple accounts, email addresses, identities, or any similar
                                    tactics intended to gain an unfair advantage, obtaining more than one of each
                                    prize or circumvent these Terms of Use or Additional Rules.
                                </li>
                                <li>
                                    31. Entries involving Prohibited Conduct will be deemed void, and Qodo reserves the
                                    right, in its sole discretion, to immediately and automatically disqualify and
                                    prohibit your participation in the Promotion, including any future promotions,
                                    invalidate your entry, withhold any Prizes, restrict or terminate your access to the
                                    services, or seek damages or other remedies to the fullest extent permitted by
                                    law.
                                </li>
                                <li>
                                    32. If the Prohibited Conduct is discovered after Prizes have been awarded, Qodo
                                    reserves the right to revoke the Prizes and require you, upon demand, to
                                    immediately return the Prizes or provide equivalent compensation.
                                </li>
                                <li>
                                    33. Qodo may, but is not obligated to, monitor participation in the Promotion or to
                                    detect Prohibited Conduct and assumes no liability for any such activity.
                                </li>
                            </ul>

                            <p>
                                Sponsor
                            </p>
                            <ul>
                                <li>
                                    34. This Promotion is not endorsed by, affiliated, or associated with, maintained, or
                                    sponsored by any third party (including by &quot;X&quot;) other than Qodo, except as
                                    expressly set forth in the applicable Additional Rules.
                                </li>
                                <li>
                                    35. All products, services and company names referenced or included are the
                                    registered trademarks of their original owners. The use of any mark, name,
                                    image, or likeness is for identification and reference purposes only and does not
                                    imply any association with the trademark holder, respective individual, or their
                                    brand.
                                </li>
                                <li>
                                    36. Qodo expressly disclaims any affiliation with any third-party trademarks or rights
                                    of publicity referenced or included on the Promotion, or related materials. The
                                    use of any mark, name, image, or likeness is not intended to mislead, confuse
                                    the customer, or infringe on the copyright, rights of publicity, or trademark of any
                                    third party. Such use in no way indicates any relationship with any third party, nor
                                    does it signify that any such third party is the source of, endorses, approves of, or
                                    sponsors the Promotions or our services. We make no commercial claim to the
                                    use of any copyright, rights of publicity, or trademark of any third party, or
                                    suggestion of sponsorship or endorsement, and any such use is provided for
                                    informational purposes only.
                                </li>
                            </ul>

                            <p>
                                General Terms
                            </p>

                            <ul>
                                <li>
                                    37. By participating in any Promotion, you hereby consent to Qodo’s usage of any
                                    one or more of the following for on-air broadcast, online usage or for any other
                                    advertising and promotional purpose in any medium whatsoever without payment
                                    of any additional consideration: your name; voice; likeness; biographical
                                    information; participation in the Promotion; Prizes won; and the substance of the
                                    your entry form or any other Promotion submissions. You hereby grant Qodo a
                                    perpetual, unlimited, non-exclusive, royalty-free, right and license to use any or
                                    all of the foregoing in any manner as determined by us in our sole discretion. All
                                    processing of personal data by us will be made in accordance with the terms of
                                    our <a href="https://www.qodo.ai/privacy-policy/" target="_blank">Privacy Policy</a>.
                                </li>
                                <li>
                                    38. To the extent permitted by applicable law, Qodo reserves the right, at any time
                                    and in its sole discretion, with or without prior notice, to modify or change these
                                    Terms, any applicable Additional Rules, Prizes amounts, or the Promotion
                                    (including the Promotion Period), and to terminate, suspend, cancel, declare any
                                    Promotion null and void, or rescind any Prizes. Without limiting the foregoing,
                                    Qodo may exercise such rights, including without limitation: (i) as reasonably
                                    necessary to comply with applicable law or a request from a governmental authority or regulator; (ii) if the Terms, applicable Additional Rules, or the integrity
                                    of the Promotion are violated or compromised in any manner by any person,
                                    including, without limitation, to address fraud, cheating, tampering, security
                                    vulnerabilities, or other conduct or technical issues that compromise or may
                                    compromise the integrity or proper administration of the Promotion, whether
                                    caused intentionally or unintentionally and whether by a participant or any other
                                    person; or (iii) if circumstances beyond Qodo’s reasonable control render the
                                    Promotion illegal, impracticable, or materially interfere with its conduct, including,
                                    without limitation, natural disasters, public health emergencies or epidemics, acts
                                    of God, acts of war or terrorism, civil disturbances, governmental orders or
                                    regulations, court orders, labor disputes, or widespread technical or platform
                                    outages or failures.
                                </li>
                                <li>
                                    39. Notwithstanding the above, Qodo will make reasonable efforts (to the extent
                                    possible) to provide notice of any material changes to the Terms, the Additional
                                    Rules or the Promotion prior to the beginning of a Promotion. You acknowledge
                                    that you shall be responsible for staying up to date with any and all changes
                                    made to the Terms, Additional Rules or a Promotion. In the event of such
                                    modifications, your continued participation in the Promotion constitutes
                                    acceptance of the modified Terms, Additional Rules or the Promotion.
                                </li>
                                <li>
                                    40. If any portion of these Terms, or the Additional Rules as applicable, is found to
                                    be unenforceable or unlawful for any reason, including because it is found to be
                                    unconscionable, (a) the unenforceable or unlawful provision will be severed from
                                    these Terms or Additional Rules (as applicable); (b) severance of the
                                    unenforceable or unlawful provision will have no impact whatsoever on the
                                    remainder of these Terms or Additional Rules (as applicable); and (c) the
                                    unenforceable or unlawful provision may be revised to the extent required to
                                    render these Terms, or Additional Rules (as applicable), enforceable or valid, and
                                    the rights and responsibilities of the parties will be interpreted and enforced
                                    accordingly, so as to preserve these Terms, or Addition Rules (as applicable),
                                    and the intent of these Terms, or Additional Rules (as applicable), to the fullest
                                    possible extent.
                                </li>
                                <li>
                                    41. In case of a conflict between these Terms and the Additional Rules or the Terms
                                    of Use, the order of precedence shall be as follows: (i) Additional Rules (as
                                    applicable); (ii) Terms; and (iii) Terms of Use.
                                </li>
                                <li>
                                    42. If any potential winner is required by any applicable law, these Terms, or by any
                                    other rules to comply with additional conditions or requirements in order to
                                    participate in the Promotion and receive the Prizes, such potential winner must
                                    fully comply with such requirements within the time set by us as a pre-condition
                                    to receiving the Prizes.
                                </li>
                                <li>
                                    43. Third party terms and conditions may apply to certain Prizes, where applicable,
                                    and your acceptance of such terms and conditions may be required to be
                                    rewarded with the Prizes. You acknowledge that Qodo has no connection or
                                    liability to such third parties, and that region and redemption limitation on the gift-
                                    card may apply. Any problems or complaints that you may have with regard to
                                    such third parties should be directed to such third parties.
                                </li>
                                <li>
                                    44. Our decisions regarding the administration and operation of the Promotion,
                                    including, without limitation, the selection of potential winners are final and
                                    binding. Qodo&#39;s systems will be used to determine when the Promotion Period
                                    has commenced or concluded, and such determination shall not be disputed for
                                    any reason.
                                </li>
                                <li>
                                    45. Participants who provide their full name and email address as part of the
                                    Promotion, hereby consent to receive commercial and marketing
                                    communications from Qodo to the extent permitted by applicable law. Where
                                    required by applicable law in a participant’s jurisdiction, Qodo will obtain the
                                    participant’s prior consent before sending such communications. Participants
                                    may opt out at any time in accordance with applicable law, and opting out will not
                                    affect participation in the Promotion or eligibility to win or receive any Prizes.
                                </li>
                                <li>
                                    46. Qodo&#39;s shall be the sole arbiter in all matters relating to the Promotion and the
                                    interpretation of these Terms. The decisions of Qodo will be final as to all
                                    matters, including, without limitation, whether any entry submitted is valid or not
                                    and if all questions were answered correctly or not.
                                </li>
                                <li>
                                    47. Any and all disputes under these Terms or the Additional Rules, as applicable,
                                    shall be governed by and construed in accordance with the laws of the State of
                                    Israel and shall be subject to the exclusive jurisdiction of the courts of Tel Aviv.
                                </li>
                            </ul>

                            <p>
                                Contact Us
                            </p>
                            <ul>
                                <li>
                                    48. If you have any questions regarding these Terms or the operation of the Promotion, please contact us at: dana.f@qodo.ai.
                                    <br></br>
                                    Codium Ltd. address: Harbba 21, Tel Aviv , Israel
                                </li>
                            </ul>
                        </div>

                        <button onClick={() => setOpenTerms(false)}>
                            Close
                        </button>
                    </div>
                </div>
            )}

        </>

    );
}
